/**
 * servicing eapi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JuniorPilotRequestApplicationInformationBoundInformationInnerAccompanyOnDepartureInformation } from './juniorPilotRequestApplicationInformationBoundInformationInnerAccompanyOnDepartureInformation';
import { JuniorPilotRequestApplicationInformationBoundInformationInnerGuardianInformation } from './juniorPilotRequestApplicationInformationBoundInformationInnerGuardianInformation';
import { JuniorPilotRequestApplicationInformationBoundInformationInnerMeetingOnArrivalInformation } from './juniorPilotRequestApplicationInformationBoundInformationInnerMeetingOnArrivalInformation';

export interface JuniorPilotRequestApplicationInformationBoundInformationInner {
  /**
   * バウンドID
   */
  airBoundId: string;
  /**
   * 申込種別<br/> application:ジュニアパイロットサービスの登録<br/> notRequire:ケア不要の旨の登録<br/> cancel:取消
   */
  applicationType: JuniorPilotRequestApplicationInformationBoundInformationInner.ApplicationTypeEnum;
  accompanyOnDepartureInformation?: JuniorPilotRequestApplicationInformationBoundInformationInnerAccompanyOnDepartureInformation;
  meetingOnArrivalInformation?: JuniorPilotRequestApplicationInformationBoundInformationInnerMeetingOnArrivalInformation;
  guardianInformation?: JuniorPilotRequestApplicationInformationBoundInformationInnerGuardianInformation;
}
export namespace JuniorPilotRequestApplicationInformationBoundInformationInner {
  export type ApplicationTypeEnum = 'application' | 'notRequire' | 'cancel';
  export const ApplicationTypeEnum = {
    Application: 'application' as ApplicationTypeEnum,
    NotRequire: 'notRequire' as ApplicationTypeEnum,
    Cancel: 'cancel' as ApplicationTypeEnum,
  };
}
